// eslint-disable-next-line @typescript-eslint/no-var-requires
const packageJson = require('../package.json');

export const sdkVersion = packageJson.version;
export const sdkName = 'js-client-sdk';
